import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';
import { DebounceInput } from 'react-debounce-input';

import IconErrorNoticeOutline from 'Assets/img/icon-error-notice-outline.svg';
import InformationBubble from 'Components/information-bubble';

import './Search.scss';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      typedTerm: '',
    };
  }

  componentDidUpdate(prevProps) {
    if(!this.props.isMreFilterPaneVisible && (prevProps.isMreFilterPaneVisible !== this.props.isMreFilterPaneVisible)  && this.props.reportName === "MRE") {
     this.setState({typedTerm:''});
    }

  }
/* eslint-disable no-undef */
  onBlur = (event) => {
     /* eslint-enable no-undef */
    this.props.onBlur(event);
    this.setState({ focused: false });
  }
/* eslint-disable no-undef */
  onFocus = (event) => {
     /* eslint-enable no-undef */
    if (event.target.value !== '') return;
    this.setState({ focused: true }, this.props.onFocus(''));
  }
  /* eslint-disable no-undef */
  handleFilterInputChange = (event) => {
     /* eslint-enable no-undef */
    if (!this.props.pressEnterToSearch) this.props.onChange(event.target.value);
  }

  handleClickChange = (event) => {
    /* eslint-enable no-undef */
    if (this.props.pressEnterToSearch && event.key === 'Enter') {
      this.setState({ error: '' });
      this.props.onChange(event.target.value).then((result) => {
        if (result) this.setState({ error: result });
      });
    } else {
      this.props.onKeyUp && this.props.onKeyUp(event);
      if (event.key === 'Backspace' && this.state.typedTerm === event.target.value) {
        this.setState({ typedTerm: '' });
      } else {
        this.setState({ typedTerm: event.target.value });
      }
    }
  }


  render() {
    const { manager, debounceTimeout, minLength, error, placeholder, filterText, extraClass } = this.props;
    const { focused, typedTerm } = this.state;
    const errorMessage = this.state.error || error;
    const containerClass = classes('search', {
      'search-manager': manager,
      focused,
      [extraClass]: extraClass,
      hideGlass: typedTerm,
      'mre-font-size': this.props.reportName === 'MRE'
    });
    const className = "search-field hidden-s _";
    return (
      <div className={containerClass}>
        <DebounceInput
          className={className}
          onBlur={this.onBlur}
          onChange={this.handleFilterInputChange}
          onFocus={this.onFocus}
          onKeyUp={this.handleClickChange}
          type="text"
          placeholder={placeholder}
          value={filterText || typedTerm}
          debounceTimeout={debounceTimeout}
          minLength={minLength}
        />
        <DebounceInput
          className="search-field show-s"
          onBlur={this.onBlur}
          onChange={this.handleFilterInputChange}
          onFocus={this.onFocus}
          type="text"
          placeholder=""
          value={filterText || typedTerm}
          debounceTimeout={debounceTimeout}
          minLength={minLength}
        />
        {errorMessage &&
          <InformationBubble
            id={errorMessage}
            tooltipContent={errorMessage}
          >
            <img src={IconErrorNoticeOutline} alt="error notice" />
          </InformationBubble>
        }
      </div>
    );
  }
}

Search.propTypes = {
  error: PropTypes.string,
  filterText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  manager: PropTypes.bool,
  debounceTimeout: PropTypes.number,
  minLength: PropTypes.number,
  onBlur: PropTypes.func,
  pressEnterToSearch: PropTypes.bool,
};

Search.defaultProps = {
  error: '',
  placeholder: '',
  manager: false,
  debounceTimeout: 0,
  minLength: 0,
  onFocus: () => { },
  onBlur: () => {},
  pressEnterToSearch: false,
  isMreFilterPaneVisible: false,
  reportName: '',
};

export default Search;
